import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class extends BaseModule {
  init() {
    this.openState = false
    this.btn = this.el.querySelector('[data-navigation-burger]')
    this.btn.addEventListener('click', () => {
      this.toggleMenu()
    })

    this.languageSwitcher()
  }

  languageSwitcher() {
    let state = false
    const multilingual = document.querySelector('[data-navigation-multilingual]')
    const toggle = document.querySelector('[data-navigation-multilingual-toggle ]')
    toggle.addEventListener('click', () => {
      state = !state
      multilingual.classList.toggle('is-active', state)
      toggle.setAttribute('aria-expanded', state)
    })
  }
  
  toggleMenu() {
    if (this.openState) {
      window.lenis.start()
      this.closeMenu()
    } else {
      window.lenis.stop()
      this.openMenu()
    }
  }

  async closeMenu() {
    if (!this.openState) return

    document.body.classList.remove('has-menu-opened')
    // this.panelTimeline.reverse()
    this.openState = false
    this.btn.setAttribute('aria-expanded', false)
  }

  async openMenu() {
    if (this.openState) return

    document.body.classList.add('has-menu-opened')
    // this.panelTimeline.play()
    this.openState = true
    this.btn.setAttribute('aria-expanded', true)
  }
}
